import EventHandler from '@pixelunion/events';
import Rte from '../utils/Rte';
import PaymentTerms from '../helpers/PaymentTerms';
import ProductDetails from '../components/ProductDetails';
import ProductGallery from '../components/ProductGallery';

function updateCart() {
  window.Shopify.getCart(cart => {
    // Update cart text
    const cartAmountWrap = document.querySelector('[data-header-cart-count]');

    if (cartAmountWrap) {
      cartAmountWrap.innerHTML = `(${cart.item_count})`;
    }
  });
}

export default class Product {
  constructor(section) {
    this.events = new EventHandler();
    this.el = section.el;
    this.data = section.data;
    this.product = this.data.product;

    this.addingToCart = false;

    this.productForm = this.el.querySelector('[data-product-form]');
    this.addToCartButton = this.productForm.querySelector('[data-product-atc]');

    this.gallery = new ProductGallery(this.el.querySelector('[data-product-gallery]'), {
      enable_image_zoom: this.data.gallery_image_zoom,
      enable_video_autoplay: this.data.gallery_video_autoplay,
      enable_video_looping: this.data.gallery_video_looping,
    });

    this.productDetails = new ProductDetails({
      el: this.el,
      product: this.product,
      settings: this.data,
      onVariantChange: ({ variant }) => this.gallery.selectMediaByVariant(variant),
    });

    this.rtes = [];

    this.el.querySelectorAll('[data-rich-text-area]').forEach(el => this.rtes.push(new Rte({ el })));

    window.Shopify.onError = XMLHttpRequest => this.handleErrors(XMLHttpRequest);
    this.events.register(this.addToCartButton, 'click', event => this.addToCart(event));

    this.paymentTerms = new PaymentTerms(this.el);
  }

  addToCart(e) {
    if (this.data.enable_cart_redirection || document.querySelector('.template-cart')) {
      return;
    }

    e.preventDefault();

    const productMessageWrappers = this.el.querySelectorAll('.product-message');

    productMessageWrappers.forEach(el => el.parentNode.removeChild(el));

    if (this.addingToCart) return;
    const data = new FormData(this.productForm);

    if (!this.addToCartButton.disabled) {
      this.addingToCart = true;
      this.addToCartButton.classList.add('product-details__add-to-cart-button--loading');

      fetch(window.Theme.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/javascript',
        },
        body: data,
      })
        .then(response => {
          if (response.status !== 200) {
            throw new Error(response.status);
          } else {
            return response.json();
          }
        })
        .then(() => {
          const message = this.data.atc_message_success
            .replace('{{ product }}', `${this.product.title}`)
            .replace('{{ cart_link }}', `<a href="${window.Theme.routes.cart_url}">${this.data.atc_cart_link}</a>`)
            .replace('{{ continue_link }}', `<a href="${window.Theme.routes.all_products_collection_url}">${this.data.atc_continue_shopping}</a>`)
            .replace('{{ checkout_link }}', `<form class="product-message__form" action="${window.Theme.routes.cart_url}" method="POST"><button class="product-message__btn" type="submit" name="checkout">${this.data.atc_checkout_link}</button></form>`);

          setTimeout(() => {
            this.addToCartButton.classList.remove('product-details__add-to-cart-button--loading');
            const productMessageWrapper = document.createElement('div');

            productMessageWrapper.classList.add('product-message');
            productMessageWrapper.innerHTML = message;

            const productAddToCart = this.el.querySelector('.product-details__add-to-cart-area');

            productAddToCart.appendChild(productMessageWrapper);

            this.addingToCart = false;

            updateCart();
          },
          500);
        })
        .catch(error => this.handleErrors(error));
    }
  }

  handleErrors(error) {
    setTimeout(() => {
      this.addToCartButton.classList.remove('product-details__add-to-cart-button--loading');

      const productMessageWrapper = document.createElement('div');
      productMessageWrapper.classList.add('product-message', 'errors');
      const productAddToCart = this.el.querySelector('.product-details__add-to-cart-area');
      let errorMsg = this.data.generic_error_msg;

      if (error) {
        if (error.responseJSON) {
          errorMsg = error.responseJSON.description;
        } else if (error.message === "401") {
          errorMsg = `${errorMsg} ${this.data.error_msg_unauthorized}`;
        }
      }

      productMessageWrapper.innerHTML = errorMsg;
      productAddToCart.appendChild(productMessageWrapper);
      this.addingToCart = false;
    },
    1000);
  }

  unload() {
    this.events.unregisterAll();
    this.productDetails.unload();
    this.rtes.forEach(rte => rte.unload());
  }

  onSectionUnload() {
    this.unload();
  }
}
